'use client';
import React, { useEffect, useRef } from 'react';
import UGCHeader from './components/UGCHeader';
import UGCHero from './components/UGCHero';
import TrustBar from './components/TrustBar';
import FeaturesSection from './components/FeaturesSection';
import ShowcaseSection from './components/ShowcaseSection';
import HowItWorks from './components/HowItWorks';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import FinalCTA from './components/FinalCTA';
import UGCFooter from './components/UGCFooter';
import EmailSubscribeSection from './components/EmailSubscribeSection';

export default function HomePage() {
  const cursorDotRef = useRef<HTMLDivElement>(null);
  const cursorRingRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const dot = cursorDotRef.current;
    const ring = cursorRingRef.current;
    if (!dot || !ring) return;

    let ringX = 0, ringY = 0;
    let mouseX = 0, mouseY = 0;

    const onMouseMove = (e: MouseEvent) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.left = `${mouseX}px`;
      dot.style.top = `${mouseY}px`;
    };

    const animateRing = () => {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.left = `${ringX}px`;
      ring.style.top = `${ringY}px`;
      requestAnimationFrame(animateRing);
    };

    window.addEventListener('mousemove', onMouseMove, { passive: true });
    const rafId = requestAnimationFrame(animateRing);

    const onEnter = () => {
      if (ring) { ring.style.width = '60px'; ring.style.height = '60px'; ring.style.borderColor = 'rgba(139,92,246,0.6)'; }
      if (dot) { dot.style.width = '4px'; dot.style.height = '4px'; }
    };
    const onLeave = () => {
      if (ring) { ring.style.width = '36px'; ring.style.height = '36px'; ring.style.borderColor = 'rgba(139,92,246,0.3)'; }
      if (dot) { dot.style.width = '8px'; dot.style.height = '8px'; }
    };

    const hoverables = document.querySelectorAll('a, button, input, label');
    hoverables.forEach(el => {
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
    });

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      cancelAnimationFrame(rafId);
      hoverables.forEach(el => {
        el.removeEventListener('mouseenter', onEnter);
        el.removeEventListener('mouseleave', onLeave);
      });
    };
  }, []);

  return (
    <div className="ugc-root">
      {/* Film grain */}
      <div className="film-grain" aria-hidden="true" />

      {/* Custom cursor */}
      <div ref={cursorDotRef} className="ugc-cursor-dot" aria-hidden="true" />
      <div ref={cursorRingRef} className="ugc-cursor-ring" aria-hidden="true" />

      <UGCHeader />

      <main>
        <UGCHero />
        <TrustBar />
        <FeaturesSection />
        <ShowcaseSection />
        <HowItWorks />
        <TestimonialsSection />
        <PricingSection />
        <EmailSubscribeSection />
        <FinalCTA />
      </main>

      <UGCFooter />
    </div>
  );
}